import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import { UserRoleEnum } from "src/app/shared/models/enums/user-role.enum";
import { Store } from "src/app/shared/models/store";

@Component({
	selector: "app-venue-administration",
	templateUrl: "./venue-administration.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class VenueAdministrationComponent implements OnInit {
	changesToSave: boolean = false;

	selectedVenue: Store;

	venueList: Store[];

	constructor(public app: AppService, public venueService: OOVenueService, private focuslink: FocuslinkService, public userService: UserService) {}

	ngOnInit(): void {
		this.venueListGetAll();
	}

	async onSave() {
		try {
			await this.focuslink.venuePost(this.selectedVenue.key, this.selectedVenue);
			this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `Venue saved` });
		} catch (error) {
			this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: "", detail: `Error saving venue` });
		}
	}

	async venueListGetAll() {
		console.log(`get venue`);
		const resp = await this.focuslink.venueGetAll(
			this.userService.userSubscription.value.role >= UserRoleEnum.SUPERADMIN ? undefined : this.userService.userSubscription.value.dealerKey,
			undefined
		);

		this.venueList = resp
			.sort((a, b) => (a.key > b.key ? 1 : -1))
			.map((i) => {
				const store = new Store(i);
				store.displayName = `${store.key} - ${store.name}`;
				return store;
			});

		this.selectedVenue = this.venueList[0];
	}
}
